import React, { forwardRef, useImperativeHandle } from "react";
import { Form, Input, Row, Col } from "antd";

const UserInfoRentalForm = forwardRef((props, ref) => {
  console.log('sss', props.initialValues);

  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    submit: () => {
      form.submit();
    },
    validate: async () => {
      try {
        const values = await form.validateFields(); // Validate form fields
        return { valid: true, values }; // Return valid status and values
      } catch (error) {
        return { valid: false, errors: error.errorFields }; // Return errors if validation fails
      }
    },
    values: () => {
      return form.getFieldsValue();
    }
  }));

  const onFinish = (values) => {
    console.log("Form Values:", values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={
        props.initialValues
      }
    >

      <div className='text-lg !text-white font-bold mt-4' style={{ color: 'black', backgroundColor: '#00803e', margin: '1rem', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
        User details
      </div>

      <Row gutter={16} style={{ margin: '1rem', padding: '1rem', borderRadius: '8px', border: '1px solid #00803e' }}>
        <Col sm={24} md={24} lg={12} >
          <Form.Item rules={[{ required: true }]} label="Name" name="name">
            <Input placeholder="Enter your name" />
          </Form.Item>
        </Col>
        <Col sm={24} md={24} lg={12} >
          <Form.Item rules={[{ required: true, type: 'email' }]} label="Email" name="email">
            <Input placeholder="Enter your email address" />
          </Form.Item>
        </Col>
        <Col sm={24} md={24} lg={12} >
          <Form.Item 
            rules={[
              { required: true, message: 'Phone number is required' },
              {
                pattern: /^\+[1-9]\d{1,14}$/,
                message: 'Please enter a valid phone number with country code (e.g. +923001234567)'
              }
            ]} 
            label="Phone number" 
            name="phone"
          >
            <Input placeholder="Enter phone number with country code (e.g. +923001234567)" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
});

export default UserInfoRentalForm;
